import { useState, useEffect, useContext, useRef } from 'react';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import PageLoader from '../PageLoader';
import BtnLoader from '../BtnLoader';
import { AnimatePresence, motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyOrder from "../../assets/Image/emptyOrder.png";
import ImageLoad from '../ImageLoad';
import CompletedModel from '../Model/CompletedModel';
import UpcomingModel from '../Model/UpcomingModel';
import { socket } from '../../socket';
import CancelModel from '../Model/CancelModel';
import { useTranslation } from 'react-i18next';
const MyRides = () => {
    const { t } = useTranslation();

    const { BaseUrl, handleCallApi, setShowToast, setToastMsg, paymentRes, setPaymentRes } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [selectStatus, setSelectStatus] = useState("upcoming");
    const [rideList, setRideList] = useState([]);
    const [apiLoading, setApiLoading] = useState(false);
    const [showModel, setShowModel] = useState("");
    const [modelData, setModelData] = useState(null);
    const [rating, setRating] = useState(1);
    const [reviewData, setReviewData] = useState([]);
    const [selectDReview, setSelectDReview] = useState([]);
    const [input, setInput] = useState("");
    const [driverDetail, setDriverDetail] = useState(null);

    const lastFetchedStatusRef = useRef(null);
    const ReviewRef = useRef(false);
    const currentStatusRef = useRef(selectStatus);
    currentStatusRef.current = selectStatus;

    const Location = useLocation();
    const navigate = useNavigate();

    const currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        handleGetReviewData();
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(Location.search);
        const queryTab = queryParams.get("tab");
        const stateTab = Location.state?.tab;
        const targetTab = queryTab || stateTab;
        if (targetTab && ["upcoming", "scheduled", "completed", "cancelled"].includes(targetTab) && targetTab !== selectStatus) {
            setSelectStatus(targetTab);
        }
    }, [Location]);

    useEffect(() => {
        if (lastFetchedStatusRef.current === selectStatus) return;
        lastFetchedStatusRef.current = selectStatus;
        handleFetchData(selectStatus);
    }, [selectStatus]);

    useEffect(() => {
        if (!paymentRes) return;
        if (paymentRes === "PaymentDone") {
            handleOrderCompleted();
        } else {
            setShowToast(true);
            setToastMsg("Payment was faild! please try agine");
        }
        setPaymentRes("");
    }, [paymentRes]);

    useEffect(() => {
        const uid = secureLocalStorage.getItem("Userid");
        if (!uid) return;

        const handleVehicleRideCompleteClient = (data) => {
            console.log("Vehicle_Ride_Complete_Client in MyRides", data);
            setModelData((prev) => {
                const ride = rideList.find((item) => item.id == data.request_id);
                if (ride) {
                    return { ...ride, id: data.request_id };
                }
                if (prev) {
                    return { ...prev, id: data.request_id };
                }
                return { id: data.request_id, d_id: data.d_id };
            });
            setShowModel("Review");
            handleFetchData();
        };

        const handleVehicleReviewCompleteClient = (data) => {
            console.log("Vehicle_Review_Complete_Client in MyRides", data);
            setShowModel("");
            setModelData(null);
            handleFetchData();
        };

        const handleVehicleAcceptCancel = (data) => {
            console.log("Vehicle_Accept_Cancel / Vehicle_Ride_Cancel_Client received in MyRides", data);
            setShowModel("");
            setModelData(null);
            handleFetchData();
        };

        socket.on(`Vehicle_Ride_Complete_Client${uid}`, handleVehicleRideCompleteClient);
        socket.on(`Vehicle_Review_Complete_Client${uid}`, handleVehicleReviewCompleteClient);
        socket.on(`Vehicle_Accept_Cancel${uid}`, handleVehicleAcceptCancel);
        socket.on(`Vehicle_Ride_Cancel_Client${uid}`, handleVehicleAcceptCancel);
        return () => {
            socket.off(`Vehicle_Ride_Complete_Client${uid}`, handleVehicleRideCompleteClient);
            socket.off(`Vehicle_Review_Complete_Client${uid}`, handleVehicleReviewCompleteClient);
            socket.off(`Vehicle_Accept_Cancel${uid}`, handleVehicleAcceptCancel);
            socket.off(`Vehicle_Ride_Cancel_Client${uid}`, handleVehicleAcceptCancel);
        };
    }, [rideList]);

    const handleFetchData = async (targetStatus = selectStatus) => {
        setApiLoading(true);
        const uid = secureLocalStorage.getItem("Userid");
        const Response = await handleCallApi("Post", "customer/all_service_request", { uid, status: targetStatus });
        if (targetStatus !== currentStatusRef.current) return;
        if (Response && Response.data) {
            const RequestList = Response.data.Reuqest_list || [];
            setRideList(RequestList);
            setLoading(false);
            setApiLoading(false);
            if (Location.state && !showModel) {
                let GetRideDetails;
                if (Location.state?.status === 1) {
                    GetRideDetails = RequestList.find((item) => item.d_id == Location.state.d_id);
                } else {
                    GetRideDetails = RequestList.find((item) => item.id == Location.state.id);
                }
                if (GetRideDetails) {
                    setShowModel(targetStatus);
                    setModelData(GetRideDetails);
                }
                secureLocalStorage.removeItem("timerData");
                navigate(Location.pathname, { replace: true, state: null });
            }
        } else {
            setRideList([]);
            setLoading(false);
            setApiLoading(false);
        }
    }

    const handleGetReviewData = async () => {
        if (ReviewRef.current) return;
        ReviewRef.current = true;
        const Response = await handleCallApi("Get", "customer/review_data");
        if (Response && Response.data && Response.data.review_list) {
            setReviewData(Response.data.review_list);
        }
    }

    const handleSelectDefReview = (title) => {
        if (selectDReview.includes(title)) {
            const Filter = selectDReview.filter((item) => item !== title);
            setSelectDReview(Filter);
        } else {
            setSelectDReview((prev) => [...prev, title]);
        }
    }

    const handleAddReview = async () => {
        const uid = secureLocalStorage.getItem("Userid");
        const ApiBody = {
            uid,
            d_id: modelData?.d_id,
            request_id: modelData?.id,
            def_review: selectDReview.join(","),
            review: input,
            tot_star: rating
        }

        const Response = await handleCallApi("Post", "customer/tbl_review", ApiBody);
        if (Response && Response.data) {
            setShowToast(true);
            setToastMsg(Response.data.message);
            setShowModel("");
            setModelData(null);
        }
    }

    const base64ToFile = (base64String, filename) => {
        if (!base64String || typeof base64String !== "string" || !base64String.includes(",")) {
            return null;
        }
        const arr = base64String.split(",");
        const match = arr[0].match(/:(.*?);/);
        if (!match) return null;
        const mime = match[1];
        const bstr = atob(arr[1]);

        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    };

    const handleOrderCompleted = async () => {
        const LocalData = secureLocalStorage.getItem("Booking");

        if (LocalData) {
            const { payment_img, uid, d_id, request_id, wallet, payment_id } = JSON.parse(LocalData);

            const formdata = new FormData();
            if (payment_img && typeof payment_img === "string" && payment_img.includes(",")) {
                const fileImage = base64ToFile(payment_img, "payment.jpg");
                if (fileImage) {
                    formdata.append("payment_img", fileImage);
                }
            }
            formdata.append("uid", uid);
            formdata.append("d_id", d_id);
            formdata.append("request_id", request_id);
            formdata.append("wallet", wallet);
            formdata.append("payment_id", payment_id);

            const Response = await handleCallApi("Post", "customer/vehicle_ride_complete", formdata);

            if (Response && Response.data && Response.data.ResponseCode === 200) {
                const GetRideDetail = rideList.find((item) => item.id == request_id);
                setModelData({ ...GetRideDetail, id: Response.data?.request_id });
                setShowModel("Review");
                handleFetchData();

                socket.emit("Vehicle_Ride_Complete", {
                    d_id,
                    request_id
                });
            }
        }
    };

    const handleGetDriverDetail = async () => {
        const Response = await handleCallApi("Post", "customer/driver_profile_detail", { d_id: modelData?.d_id });
        if (Response && Response.data) {
            setDriverDetail(Response.data?.d_detail);
            setShowModel("Driver");
        }
    }

    return (
        <div>

            {!loading && <div className="width-container p-3">

                <div className="mb-6 leading-4">
                    <h1 className="text-3xl font-bold text-slate-900">{t("Rides History")}</h1>
                    <p className="text-slate-500">
                        {t("View your completed rides and upcoming bookings.")}
                    </p>
                </div>

                <div className="flex items-center gap-3 border-b border-gray-300">
                    {["upcoming", "scheduled", "completed", "cancelled"].map((item, index) => {
                        const IsActive = item === selectStatus;
                        return <div key={index} onClick={() => setSelectStatus(item)} className={`cursor-pointer border-b-2 py-2 px-3 ${IsActive ? "border-[--bg-color]" : "border-transparent"}`}>
                            <h1 className="font-semibold">{t(item.charAt(0).toUpperCase() + item.slice(1))}</h1>
                        </div>
                    })}
                </div>


                {apiLoading && <div className="h-[400px]">
                    <BtnLoader CustomeStyle={"bg-[--bg-color]"} />
                </div>}

                {!apiLoading && <div className="mt-5">
                    {rideList.length >= 1
                        ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-stretch gap-5">
                            {rideList.map((item, index) => {
                                const routeStops = (() => {
                                    const pickupStop = { type: "pickup", title: item.pickup?.title || "", colorClass: "location-icon-green", textClass: "text-green-600", label: t("PICKUP") };
                                    const stops = item.drop_list || [];
                                    
                                    if (stops.length > 1) {
                                        const firstIntermediate = {
                                            type: "stop",
                                            title: item.drop?.title || "",
                                            colorClass: "location-icon-yellow",
                                            textClass: "text-yellow-600",
                                            label: `${t("STOP")} 1`
                                        };
                                        const remainingCount = stops.length - 1;
                                        const collapsedStop = {
                                            type: "collapsed",
                                            title: `+ ${remainingCount} ${remainingCount === 1 ? t("more stop") : t("more stops")}`,
                                            colorClass: "location-icon-yellow",
                                            textClass: "text-gray-500 font-normal italic",
                                            label: ""
                                        };
                                        const finalStop = stops[stops.length - 1];
                                        const finalDestination = {
                                            type: "drop",
                                            title: finalStop?.title || "",
                                            colorClass: "location-icon-red",
                                            textClass: "text-red-600",
                                            label: t("DESTINATION")
                                        };
                                        return [pickupStop, firstIntermediate, collapsedStop, finalDestination];
                                    } else if (stops.length === 1) {
                                        const intermediateStops = [
                                            {
                                                type: "stop",
                                                title: item.drop?.title || "",
                                                colorClass: "location-icon-yellow",
                                                textClass: "text-yellow-600",
                                                label: `${t("STOP")} 1`
                                            }
                                        ];
                                        const finalStop = stops[0];
                                        const finalDestination = {
                                            type: "drop",
                                            title: finalStop?.title || "",
                                            colorClass: "location-icon-red",
                                            textClass: "text-red-600",
                                            label: t("DESTINATION")
                                        };
                                        return [pickupStop, ...intermediateStops, finalDestination];
                                    } else {
                                        const finalDestination = {
                                            type: "drop",
                                            title: item.drop?.title || "",
                                            colorClass: "location-icon-red",
                                            textClass: "text-red-600",
                                            label: t("DESTINATION")
                                        };
                                        return [pickupStop, finalDestination];
                                    }
                                })();

                                const displayName = item.m_role !== '1' && item.mode_title 
                                     ? `${t(item.mode_title)} - ${item.vehicle_name}` 
                                     : item.vehicle_name;

                                return <motion.div key={index}
                                    initial={{ opacity: 0, y: 30 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.10 }}
                                    className="bg-white rounded-2xl shadow border border-gray-200 p-6 card-hover flex flex-col justify-between">
                                    <div className="space-y-4">
                                        <div className="flex items-center gap-4">
                                            <ImageLoad src={BaseUrl + item.map_img} CustomeStyle={"w-[50px] h-[50px] bg-[#4038ff]/10 rounded-[10px]"} ImagStyle={"w-full h-full object-contain p-1"} alt={displayName} status={false} />
                                            <div className="leading-5">
                                                <h1 className="font-semibold">{displayName}</h1>
                                                <span className="text-gray-600 text-[14px]">{t("Booking id")} : #{item.id}</span>
                                            </div>
                                        </div>
                                        <div className="border-t border-b border-gray-50 py-3 space-y-1">
                                            <div className="flex justify-between text-sm">
                                                <span className="text-gray-500">{t("Date")} &amp; {t("Time")}</span>
                                                <span className="font-medium text-gray-900">
                                                    {item.book_date && item.book_date !== '' 
                                                        ? `${item.book_date} | ${item.book_time}` 
                                                        : (item.start_time && item.start_time.includes(",") 
                                                            ? `${item.start_time.split(",")[0]} | ${item.start_time.split(",")[1]}` 
                                                            : item.start_time || '')
                                                    }
                                                </span>
                                            </div>
                                             <div className="flex justify-between text-sm">
                                                 <span className="text-gray-500">{t("Estimated Fare")}</span>
                                                 <span className="font-medium text-gray-900">{currency + Number(item.final_price || item.price || 0).toFixed(2)} • {item.p_name}</span>
                                             </div>
                                        </div>
                                        <div className="space-y-1">
                                            {routeStops.map((stop, idx) => (
                                                <div key={idx} className="flex gap-3">
                                                    <div className="flex flex-col items-center pt-1.5 w-5 flex-shrink-0 relative">
                                                        {stop.type === "collapsed" ? (
                                                            <div className="w-2.5 h-2.5 rounded-full bg-gray-300 border border-gray-400 flex-shrink-0 my-1 relative z-10"></div>
                                                        ) : (
                                                            <div className={stop.colorClass}></div>
                                                        )}
                                                        {idx !== routeStops.length - 1 && (
                                                            <div className="absolute w-0.5 border-l-2 border-dashed border-gray-400 z-0" style={{ top: "16px", bottom: "-20px" }}></div>
                                                        )}
                                                    </div>
                                                    <div className="flex-1 pb-2">
                                                        {stop.label && (
                                                            <h1 className={`text-[12px] font-bold leading-none ${stop.textClass}`}>{stop.label}</h1>
                                                        )}
                                                        <p className={`text-sm font-medium text-gray-800 line-clamp-1 ${stop.type === "collapsed" ? "mt-0.5 text-gray-500 font-normal italic" : "mt-1"}`}>
                                                            {stop.type === "collapsed" ? stop.title : stop.title}
                                                        </p>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <button onClick={() => { setShowModel(selectStatus); setModelData(item); }} className="mt-6 w-full bg-[--bg-color] text-white py-2.5 rounded-xl italic tracking-[1px] font-medium text-sm hover:opacity-90 transition-opacity active:scale-[0.98] transform shadow-md shadow-blue-200">
                                        {t("View Details")}
                                    </button>
                                </motion.div>
                            })}
                        </div>
                        : <div className="w-full min-h-[400px] flex items-center justify-center py-8">
                            <div className="text-center bg-white p-8 rounded-2xl shadow border border-gray-150 max-w-md w-full">
                                <img src={emptyOrder} className="w-[180px] mx-auto mb-4" alt="emptyOrder" />
                                <h1 className="font-bold text-xl text-gray-900 mb-2">{t("No Order Found!")}</h1>
                                <p className="text-gray-500 mb-6">{t("Currently you don't have any orders here.")}</p>
                                <div className="flex flex-wrap justify-center gap-3">
                                    <button onClick={() => navigate("/")} className="bg-[--bg-color] text-white px-6 py-2.5 rounded-xl font-semibold hover:opacity-90 active:scale-95 duration-150 shadow-md">
                                        {t("Book a Ride")}
                                    </button>
                                    <button onClick={() => navigate("/")} className="bg-gray-150 text-gray-700 px-6 py-2.5 rounded-xl font-semibold hover:bg-gray-200 active:scale-95 duration-150">
                                        {t("Go Home")}
                                    </button>
                                </div>
                            </div>
                        </div>}
                </div>}

            </div>}

            <AnimatePresence initial={false}>
                {(showModel === "completed" || showModel === "cancelled") && <div className="model items-start py-5 overflow-y-scroll">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[550px] rounded-[10px] relative mx-3"
                    >
                        <CompletedModel pageData={modelData} setShowModel={setShowModel} showModel={showModel} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {(showModel === "upcoming" || showModel === "scheduled") && <div className="model items-start py-5 overflow-y-scroll">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[550px] rounded-[10px] relative mx-3"
                    >
                        <UpcomingModel data={modelData} setShowModel={setShowModel} handleData={handleFetchData} handleGetDriverDetail={handleGetDriverDetail} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Review" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] p-[15px] rounded-[10px] relative mx-3"
                    >

                        <div className="flex items-center justify-between">
                            <h1 className="font-semibold text-[17px]">{t("Review & Rating")}</h1>
                            <button onClick={() => setShowModel("")}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                                </svg>
                            </button>
                        </div>

                        <div className="text-center mt-3 space-y-3">
                            <h1 className="font-semibold text-[18px]">{t("How was your ride with")} {modelData?.first_name} {modelData?.last_name}</h1>
                            <div className="flex items-center justify-center gap-1">
                                {[1, 2, 3, 4, 5].map((item) => {
                                    const IsFill = item <= rating;
                                    if (IsFill) {
                                        return <svg key={item} width="30" onClick={() => setRating(item)} height="30" className="text-[--bg-color] cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.962 4.59601L14.904 8.513C15.05 8.808 15.332 9.01202 15.659 9.05902L20.1419 9.70697C20.9639 9.82597 21.292 10.834 20.697 11.412L17.456 14.557C17.219 14.787 17.111 15.118 17.167 15.443L17.9079 19.747C18.0579 20.62 17.1409 21.286 16.3549 20.875L12.467 18.84C12.175 18.687 11.827 18.687 11.536 18.84L7.65096 20.873C6.86396 21.285 5.94393 20.618 6.09493 19.743L6.83602 15.443C6.89202 15.118 6.78396 14.787 6.54696 14.557L3.30599 11.412C2.70999 10.834 3.03792 9.82597 3.86092 9.70697L8.34395 9.05902C8.66995 9.01202 8.95196 8.808 9.09896 8.513L11.041 4.59601C11.432 3.80101 12.568 3.80101 12.962 4.59601Z" fill="currentColor" />
                                        </svg>
                                    }
                                    return <svg key={item} width="30" onClick={() => setRating(item)} height="30" className="text-[--bg-color] cursor-pointer" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M16.8541 21.75C16.5651 21.75 16.275 21.681 16.006 21.54L12.1181 19.505C12.0441 19.466 11.956 19.466 11.882 19.505L7.997 21.538C7.378 21.862 6.6421 21.808 6.0761 21.396C5.5131 20.985 5.23508 20.304 5.35308 19.617L6.09405 15.316C6.10805 15.235 6.081 15.153 6.023 15.096L2.78203 11.95C2.30103 11.483 2.13009 10.796 2.33709 10.157C2.54409 9.51798 3.08601 9.06099 3.75201 8.96399L8.23406 8.31598C8.31606 8.30398 8.38605 8.25299 8.42205 8.17999L10.365 4.26202C10.675 3.63702 11.3011 3.24902 11.9991 3.24902C12.6971 3.24902 13.3231 3.63702 13.6331 4.26202L15.575 8.17902C15.612 8.25302 15.6821 8.30398 15.7641 8.31598L20.246 8.96399C20.912 9.05999 21.4541 9.51698 21.6611 10.157C21.8681 10.796 21.697 11.483 21.216 11.95L17.976 15.095C17.916 15.153 17.8901 15.235 17.9041 15.316L18.6451 19.619C18.7631 20.305 18.487 20.986 17.923 21.396C17.605 21.631 17.2301 21.75 16.8541 21.75ZM12.0001 17.976C12.2791 17.976 12.559 18.042 12.813 18.175L16.7011 20.21C16.8561 20.292 16.982 20.229 17.042 20.185C17.102 20.142 17.197 20.043 17.168 19.875L16.4271 15.571C16.3291 15.001 16.519 14.421 16.934 14.019L20.173 10.875C20.27 10.781 20.254 10.675 20.236 10.621C20.218 10.566 20.168 10.47 20.033 10.45L15.5511 9.802C14.9801 9.72 14.4871 9.36201 14.2321 8.84601L12.2911 4.92999C12.2141 4.77399 12.076 4.75098 12.001 4.75098C11.926 4.75098 11.7881 4.77399 11.7111 4.92999L9.7691 8.84698C9.5151 9.36198 9.0221 9.72 8.4511 9.802L3.96905 10.45C3.83405 10.47 3.78304 10.565 3.76604 10.621C3.74804 10.676 3.73303 10.781 3.82903 10.875L7.06902 14.02C7.48302 14.421 7.673 15.001 7.575 15.571L6.83404 19.872C6.80504 20.041 6.90111 20.14 6.96111 20.184C7.02311 20.228 7.14501 20.29 7.30401 20.209L11.189 18.176C11.441 18.043 11.7211 17.976 12.0001 17.976Z" fill="currentColor" />
                                    </svg>
                                })}
                            </div>
                            <p className="text-gray-600">{t("Great, what did you like the mast? 😍")}</p>
                            <div className="flex flex-wrap items-center justify-center gap-2">
                                {reviewData.map((item, index) => {
                                    const IsFill = selectDReview.includes(item.title);
                                    return <div key={index} onClick={() => handleSelectDefReview(item.title)} className={`w-[150px] border py-[6px] rounded-[50px] cursor-pointer text-[15px] ${IsFill ? "bg-[--bg-color] text-white" : "text-black"} transition-colors`}>
                                        <span>{item.title}</span>
                                    </div>
                                })}
                            </div>
                            <input type="text" value={input} onChange={(e) => setInput(e.target.value)} className="w-full border px-[15px] py-[8px] rounded-[10px] outline-[--bg-color]" placeholder="Tell us more..." />
                            <div className="flex items-center gap-4">
                                <button onClick={handleAddReview} className="w-full h-10 bg-[--bg-color] text-white rounded-[8px] font-bold italic tracking-[1px] hover:bg-[--bg-color-hover] transition-colors">
                                    {t("Submit")}
                                </button>
                                <button onClick={() => setShowModel("")} className="w-full h-10 bg-orange-500 text-white rounded-[8px] font-bold italic tracking-[1px] hover:bg-orange-400 transition-colors">
                                    {t("Skip")}
                                </button>
                            </div>

                        </div>

                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Cancel" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="bg-white w-[450px] p-5 rounded-[10px] relative mx-3">
                        <CancelModel setShowModel={setShowModel} data={modelData} handleFetchData={handleFetchData} />
                    </motion.div>
                </div>}
            </AnimatePresence>

            <AnimatePresence initial={false}>
                {showModel === "Driver" && <div className="model items-center">
                    <motion.div
                        key="content"
                        initial="close"
                        animate="open"
                        exit="close"
                        variants={{
                            open: { opacity: 1, y: 0 },
                            close: { opacity: 0, y: 30 },
                        }}
                        transition={{ duration: 0.3 }}
                        className="w-[460px] rounded-[16px] relative mx-3 overflow-hidden bg-white"
                        style={{ boxShadow: '0 20px 60px rgba(0,0,0,0.15)' }}
                    >

                        {/* Hero Banner with Vehicle Image */}
                        <div className="relative h-[200px] overflow-hidden">
                            <div style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                position: 'absolute', inset: 0, zIndex: 0
                            }} />
                            {driverDetail?.vehicle_image && (
                                <ImageLoad
                                    src={BaseUrl + driverDetail?.vehicle_image}
                                    CustomeStyle={"absolute inset-0 w-full h-full"}
                                    ImagStyle={"w-full h-full object-cover"}
                                    alt="vehicle"
                                    status={false}
                                />
                            )}
                            <div style={{
                                background: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 60%)',
                                position: 'absolute', inset: 0, zIndex: 1
                            }} />

                            {/* Close Button */}
                            <button
                                onClick={() => setShowModel(selectStatus)}
                                className="absolute top-3 right-3 z-10 w-[32px] h-[32px] rounded-full flex items-center justify-center transition-all duration-200 hover:scale-110"
                                style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(10px)' }}
                            >
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="white" />
                                </svg>
                            </button>

                            {/* Vehicle Info Pill on Banner */}
                            {driverDetail?.car_name && (
                                <div className="absolute bottom-3 right-3 z-10 flex items-center gap-1.5 px-3 py-1.5 rounded-full text-[12px] font-semibold text-white"
                                    style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(10px)' }}>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
                                        <path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z" />
                                    </svg>
                                    {driverDetail?.car_color ? `${driverDetail.car_color} ` : ''}{driverDetail?.car_name} · {driverDetail?.vehicle_number}
                                </div>
                            )}
                        </div>

                        {/* Profile Avatar - overlapping the banner */}
                        <div className="relative flex justify-start px-5" style={{ marginTop: '-45px', zIndex: 2 }}>
                            <div className="rounded-full p-[3px]" style={{ background: 'linear-gradient(135deg, var(--bg-color), #7c3aed)' }}>
                                <div className="w-[80px] h-[80px] rounded-full overflow-hidden bg-white p-[2px]">
                                    <ImageLoad
                                        src={BaseUrl + driverDetail?.profile_image}
                                        CustomeStyle={"w-full h-full rounded-full overflow-hidden"}
                                        ImagStyle={"w-full h-full object-cover"}
                                        alt={`${driverDetail?.first_name} ${driverDetail?.last_name}`}
                                        status={true}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Name & Verified Badge */}
                        <div className="px-5 pt-2 pb-1">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h1 className="text-[20px] font-bold text-gray-900 leading-tight">
                                        {driverDetail?.first_name} {driverDetail?.last_name}
                                    </h1>
                                    <p className="text-[13px] text-gray-400 flex items-center gap-1 mt-0.5">
                                        <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"/></svg>
                                        {t("Since")} {driverDetail?.join_date ? new Date(driverDetail.join_date).getFullYear() : ''}
                                    </p>
                                </div>
                                <div className="flex items-center gap-1.5 px-3 py-1 rounded-full"
                                    style={{ background: '#ecfdf5', border: '1px solid #a7f3d0' }}>
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="#10b981">
                                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
                                    </svg>
                                    <span className="text-[12px] font-semibold" style={{ color: '#10b981' }}>{t("Verified")}</span>
                                </div>
                            </div>
                        </div>

                        {/* Stats Cards */}
                        <div className="grid grid-cols-3 gap-3 px-5 py-3">
                            {/* Rating */}
                            <div className="rounded-[12px] p-3 text-center transition-all duration-200 hover:scale-[1.03]"
                                style={{ background: 'linear-gradient(135deg, #fef9c3, #fef3c7)', border: '1px solid #fde68a' }}>
                                <div className="flex items-center justify-center mb-1">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#f59e0b">
                                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/>
                                    </svg>
                                </div>
                                <span className="text-[20px] font-bold text-gray-800">{driverDetail?.rating || 0}</span>
                                <p className="text-[11px] text-gray-500 mt-0.5">{t("Rating")}</p>
                            </div>

                            {/* Trips */}
                            <div className="rounded-[12px] p-3 text-center transition-all duration-200 hover:scale-[1.03]"
                                style={{ background: 'linear-gradient(135deg, #e0e7ff, #ede9fe)', border: '1px solid #c7d2fe' }}>
                                <div className="flex items-center justify-center mb-1">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--bg-color)">
                                        <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                                    </svg>
                                </div>
                                <span className="text-[20px] font-bold text-gray-800">{driverDetail?.tot_complete_order || 0}</span>
                                <p className="text-[11px] text-gray-500 mt-0.5">{t("Trips")}</p>
                            </div>

                            {/* Reviews */}
                            <div className="rounded-[12px] p-3 text-center transition-all duration-200 hover:scale-[1.03]"
                                style={{ background: 'linear-gradient(135deg, #fce7f3, #fdf2f8)', border: '1px solid #fbcfe8' }}>
                                <div className="flex items-center justify-center mb-1">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#ec4899">
                                        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                                    </svg>
                                </div>
                                <span className="text-[20px] font-bold text-gray-800">{driverDetail?.tot_review || 0}</span>
                                <p className="text-[11px] text-gray-500 mt-0.5">{t("Reviews")}</p>
                            </div>
                        </div>

                        {/* Divider */}
                        <div className="mx-5" style={{ height: '1px', background: 'linear-gradient(to right, transparent, #e5e7eb, transparent)' }} />

                        {/* Languages */}
                        {driverDetail?.language && (
                            <div className="px-5 py-3">
                                <div className="flex items-center gap-2 mb-2.5">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--bg-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
                                    </svg>
                                    <h2 className="text-[14px] font-semibold text-gray-700">{t("Language")}</h2>
                                </div>
                                <div className="flex flex-wrap gap-2">
                                    {driverDetail?.language.split(",").map((item, index) => (
                                        <span key={index} className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[13px] font-medium transition-all duration-200 hover:scale-[1.05]"
                                            style={{ background: '#f0f0ff', color: 'var(--bg-color)', border: '1px solid #e0e0ff' }}>
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="var(--bg-color)" opacity="0.6"><circle cx="12" cy="12" r="6"/></svg>
                                            {item.trim()}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Preferences */}
                        {driverDetail?.prefrence_name && (
                            <div className="px-5 pt-1 pb-5">
                                <div className="flex items-center gap-2 mb-2.5">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--bg-color)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <line x1="4" y1="21" x2="4" y2="14"/><line x1="4" y1="10" x2="4" y2="3"/><line x1="12" y1="21" x2="12" y2="12"/><line x1="12" y1="8" x2="12" y2="3"/><line x1="20" y1="21" x2="20" y2="16"/><line x1="20" y1="12" x2="20" y2="3"/>
                                        <line x1="1" y1="14" x2="7" y2="14"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="17" y1="16" x2="23" y2="16"/>
                                    </svg>
                                    <h2 className="text-[14px] font-semibold text-gray-700">{t("Preference")}</h2>
                                </div>
                                <div className="flex flex-wrap gap-2">
                                    {driverDetail?.prefrence_name.split(",").map((item, index) => {
                                        const colors = [
                                            { bg: '#eef2ff', text: '#6366f1', dot: '#818cf8' },
                                            { bg: '#f0fdf4', text: '#16a34a', dot: '#4ade80' },
                                            { bg: '#fefce8', text: '#ca8a04', dot: '#facc15' },
                                            { bg: '#fdf2f8', text: '#db2777', dot: '#f472b6' },
                                            { bg: '#f0f9ff', text: '#0284c7', dot: '#38bdf8' },
                                            { bg: '#faf5ff', text: '#9333ea', dot: '#c084fc' },
                                        ];
                                        const c = colors[index % colors.length];
                                        return (
                                            <span key={index} className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-full text-[13px] font-medium transition-all duration-200 hover:scale-[1.05]"
                                                style={{ background: c.bg, color: c.text, border: `1px solid ${c.dot}30` }}>
                                                <span className="w-[6px] h-[6px] rounded-full" style={{ background: c.dot }} />
                                                {item.trim()}
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                    </motion.div>
                </div>}
            </AnimatePresence>

            <PageLoader loading={loading} />

        </div>
    )
}

export default MyRides